import React from "react";
import { Form, InputGroup } from "react-bootstrap";
//import "./ExitBotIndicatorView.scss";
import {CHANGE_ENTRY_PRICE, CHANGE_ENTRY_PRICE_CONDITION} from "../../../../actions/create-bot-type";
import { connect,useDispatch } from "react-redux";
import CustomRadio from "../modules/CustomRadio";
import LeftRightForm from "../modules/LeftRightForm";
import { Trans } from "react-i18next";

const PriceEntryView = (props) => {
  const { newBot, t } = props;
  const isBuy = newBot.strategy=='Long';
  const defaultCondition = isBuy ? "lte" : "gte";
  const entryPriceCondition = newBot.entryPriceCondition || defaultCondition;
  const dispatch = useDispatch();
  const changePriceEntry = (val) => {
    dispatch({
      type: CHANGE_ENTRY_PRICE,
      payload: val,
    });
  };
  const changeEntryPriceCondition = (val) => {
    dispatch({
      type: CHANGE_ENTRY_PRICE_CONDITION,
      payload: val,
    });
  };
  const  restrictAlphabets = (e)=>{
    var x = e.which || e.keycode;
    if(!(x>=46 && x<=57))
      e.preventDefault()
  }
  return (
    <>
        <div className="d-flex flex-column mt-4">
          {isBuy ? (
            <>
             <LeftRightForm
              left={  <CustomRadio
                  name="price_entry_condition"
                  label={t("buy-when-price-less-equal")}
                  val="lte"
                  checked={entryPriceCondition == "lte"}
                  callback={changeEntryPriceCondition}
                ></CustomRadio>}
              right={<label data-text={newBot.quoteCoin} className="input-gp-label ms-3" style={{minWidth: 180}}>
                  <Form.Control
                    as="input"
                    type="number"
                    value={entryPriceCondition == "lte" ? newBot.entryPrice : ""}
                    onChange={(e) => {
                      changeEntryPriceCondition("lte");
                      changePriceEntry(e.target.value);
                    }}
                    onKeyPress={(e) => {
                      restrictAlphabets(e);
                    }}
                    className="input-text input-gp-tex"
                  ></Form.Control>
                </label>}
                 leftCol={7}
              rightCol={5}
            ></LeftRightForm>
            <LeftRightForm
              left={  <CustomRadio
                  name="price_entry_condition"
                  label={t("buy-when-price-greater-equal")}
                  val="gte"
                checked={entryPriceCondition == "gte"}
                callback={changeEntryPriceCondition}
              ></CustomRadio>}
              right={<label data-text={newBot.quoteCoin} className="input-gp-label ms-3" style={{minWidth: 180}}>
                <Form.Control
                  as="input"
                  type="number"
                  value={entryPriceCondition == "gte" ? newBot.entryPrice : ""}
                  onChange={(e) => {
                    changeEntryPriceCondition("gte");
                    changePriceEntry(e.target.value);
                  }}
                  onKeyPress={(e) => {
                    restrictAlphabets(e);
                  }}
                  className="input-text input-gp-tex"
                ></Form.Control>
              </label>}
              leftCol={7}
             rightCol={5}
            ></LeftRightForm>
            
            </>
          ):<>
         <LeftRightForm
          left={ <h6>
            <Trans i18nKey={"sell-when-price-greater-equal"}></Trans>
            </h6>}
          right={ <label data-text={newBot.quoteCoin} className="input-gp-label">
          <Form.Control
              as="input"
              type="number"
              value={newBot.entryPrice}
              onChange={(e) => {
                changePriceEntry(e.target.value);
              }}
              onKeyPress={(e) => {
                restrictAlphabets(e);
              }}
              className="input-text input-gp-tex"
            ></Form.Control>
        </label>}
        ></LeftRightForm>
          </>}
            
        </div>
    </>
  );
};

export default connect(null)(PriceEntryView);
